import { BaseNotificationModel } from "./models/base-notification-model";

export * from './types';

export class TMNotificationSystem {
  private static _instance: TMNotificationSystem;
  private static _disableNotifications: boolean = false;

  private _isDequeueing = false;
  private _isEnqueuing = false;
  private _queue: BaseNotificationModel[] = [];

  private constructor() {
    TMNotificationSystem.enable();
  }

  public static get instance() {
    return this._instance || (this._instance = new this());
  }

  public static get enabled() {
    return !this._disableNotifications && document.visibilityState === 'visible';
  }

  static enable() {
    this._disableNotifications = false;
    window.addEventListener('visibilitychange', () => TMNotificationSystem._handleVisibilityChange());
  }

  static disable() {
    this._disableNotifications = true;
    window.removeEventListener('visibilitychange', () => TMNotificationSystem._handleVisibilityChange());
  }

  private static _handleVisibilityChange() {
    switch (document.visibilityState) {
      case 'visible':
        if (this._disableNotifications) {
          this._disableNotifications = false;
          this.instance.showEnqueuedNotifications();
        }
        break;
      case 'hidden':
        this._disableNotifications = true;
        break;
    }
  }

  private enqueueWithPriority(notification: BaseNotificationModel) {
    let index = this._queue.findIndex((item) => item.priority < notification.priority);
    if (index === -1) {
      this._queue.push(notification);
    } else {
      this._queue.splice(index, 0, notification);
    }
  }

  private dequeue() {
    return this._queue.shift();
  }

  public enqueueNotification(notification: BaseNotificationModel) {
    this._isEnqueuing = true;
    const index = this._queue.findIndex((item) => item.id === notification.id);
    if (index >= 0) {
      this._queue.splice(index, 1, notification);
    }

    if (index < 0) {
      this.enqueueWithPriority(notification);
    }
    this._isEnqueuing = false;
    this.showEnqueuedNotifications();
  }

  private showEnqueuedNotifications() {
    if (!TMNotificationSystem.enabled || this._isDequeueing || this._isEnqueuing) return;
    this._isDequeueing = true;

    const notification = this.dequeue();
    if (!notification) {
      this._isDequeueing = false;
      return;
    }
    
    const onComplete = () => {
      this._onNotificationComplete();
      notification.removeOnCompleteEventListener(onComplete);
    };

    notification.addOnCompleteEventListener(onComplete);
    notification.show();
  }

  private _onNotificationComplete() {
    this._isDequeueing = false;
    this.showEnqueuedNotifications();
  }
}
